import { render, staticRenderFns } from "./ProjectModalShare.vue?vue&type=template&id=8da95420&scoped=true&"
import script from "./ProjectModalShare.vue?vue&type=script&lang=js&"
export * from "./ProjectModalShare.vue?vue&type=script&lang=js&"
import style0 from "./ProjectModalShare.vue?vue&type=style&index=0&id=8da95420&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8da95420",
  null
  
)

export default component.exports